import React from 'react';
import LightningIcon from '../icons/LightningIcon';
import {useTranslation} from 'react-i18next';
import {StyledUpsellButton} from './styled';

interface UpsellBtnProps {
    onClick?: (e: React.SyntheticEvent) => void;
    // id?: number | string;
	disabled?: boolean;
}

const UpsellBtn: React.FC<UpsellBtnProps> = ({onClick, disabled}) => {
	const [t] = useTranslation();

	const handleClick = (e: React.SyntheticEvent) => {
		if (onClick) {
			onClick(e);
		}
	};

	return (
		<StyledUpsellButton
			icon={<LightningIcon />}
			onClick={handleClick}
			disabled={!!disabled}
		>
			{t('Upselling Available!')}
		</StyledUpsellButton>
	)
}

export default UpsellBtn;
